//import { formatCurrency } from '@firefly/utils/format-currency';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import translation_en from '../../localization/en.json';

i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false // React already does escaping
    },
    lng: navigator.language,
    resources: {
      en: {
        translation: translation_en
      }
    }
  });

/*i18n
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already does escaping
      format: function (value, format, _) {
        if (format === 'currency') {
          return formatCurrency(value);
        }
        return value;
      }
    },
    lng: navigator.language,
    en: {
      translation: translation_en
    }
  });*/

export default i18n;
